import { useContext } from 'react';
import { OrgContext } from '../contexts/OrgContext';

export function useOrg() {
  const context = useContext(OrgContext);
  if (!context) throw new Error('useOrg must be used within OrgProvider');
  return context;
}
